import {Grid, Card, CardContent, Button} from '@mui/material'

import { Plus } from 'react-feather'
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { CreditsAppliesTable } from './CreditsTable/CreditsTable';
import { AdminCreditsForm } from './CreditsForm/AdminCreditsForm';
import { useFetchInitCreditsApplies } from './hooks';

export const AdminCreditsApplies = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFetchInitCreditsApplies({location, paramsURL})

  const {
    globalStates,
} = useFetchInit

const { showForm} = globalStates


  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['142_CREDITOS_SOLICITUDES']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(!showForm)&&(
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <div className='h4 mt-1 mb-1'> Solicitudes de Creditos</div>
                    <div className="border-bottom border-dark"></div>

                    <div className="pt-4"></div>
                    <CreditsAppliesTable 
                        useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <AdminCreditsForm 
                      useFetchInit={useFetchInit}
                  />
              </div>
          </>
        )}
      </div>
    </AllowedAccess>

  )
}
